import { PropsWithChildren } from "react";
import { VStack } from "./VStack";
import { responsive } from "../styles";
import { colors } from "../styles";

export const BaseMobileLayout = ({
  children,
  padding,
}: PropsWithChildren<{ padding: string }>) => {
  return (
    <VStack
      css={responsive({
        color: colors.white,
        overflowX: "hidden",
      })}
      width="100%"
      alignItems="center"
      justifyContent="start"
      padding={padding}
    >
      <VStack
        width="100%"
        maxWidth="480px"
        alignItems="start"
        justifyContent="start"
      >
        {children}
      </VStack>
    </VStack>
  );
};
